import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The ultimate test for your webapp: Airplane wifi",
  "description": "Forget time to first byte and time to interactive. What's your time to useful?",
  "published": "2020-10-29T00:00:00.000Z",
  "hero": "./img/screenshot-1603985383962.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Remember when we could travel? Those were the days`}</p>
    <p>{`You roll up to the airport, "breeze" through security, walk endless corridors designed to keep you busy`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{`, see beautiful handbags and makeup you'd never buy, grab a bottle of overpriced water, a sandwich for the plane, and sit down in your oh so very comfortable chair.`}</p>
    <p>{`On your left is a stressed out business person frantically finishing a presentation, on your right a college kid going on vacation chill as heck not a care in the world.`}</p>
    <p>{`You're stuck in the middle seat. Forgot to buy early ... again.`}</p>
    <p>{`But hey! `}<a parentName="p" {...{
        "href": "https://youtu.be/fSgJv55x6-4"
      }}><em parentName="a">{`Two`}</em>{` arm rests`}</a>{`. 🤘`}</p>
    <p>{`You take out your laptop and get to work. Airplanes are a fun time to focus. Nothing else you can do.`}</p>
    <p>{`Unit testing was invented on an airplane, did you know? `}<a parentName="p" {...{
        "href": "https://www.zdnet.com/article/kent-beck-we-thought-we-were-just-programming-on-an-airplane/"
      }}>{`[`}{`2`}{`]`}</a></p>
    <p>{`You get the wifi package and open a website.`}</p>
    <p><img parentName="p" {...{
        "src": "/2974bfeb4f6e808eca498e0fe79413ea/The-loading-screenjh38b4.gif",
        "alt": "The loading screen"
      }}></img></p>
    <p>{`Heck yeah! Super fast all the metrics look good! Time to first byte, amazing, time to interactive, fantastic.`}</p>
    <p>{`Time to useful ... it's not on Lighthouse, who cares. 😇`}</p>
    <p>{`Airplane wifi is a beast to deal with `}{`[name|my friend]`}{`. Great bandwidth, terrible latency, poor reliability.`}</p>
    <p>{`I clocked a flight once at 50MB/s with fast.com ... 70% drop rate. Guess what 70% of connections never succeeding did to my browsing experience?`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/RLXE0PqXzWNLTKlmEF/giphy-loop.mp4?cid=7cf28b0fll7j2rx1ze2wihn3zbo4gcwbwdc4u7fskj813zqf&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Your typical webapp makes hundreds of requests for every page load. That's how you get them metrics Google cares about. Snappy first load, quick to interactive, tiny payloads.`}</p>
    <p>{`On an airplane all that turns to jank. Nothing works.`}</p>
    <p>{`Same is true for LTE when you're walking, elevators, moving to the edge of your wi-fi range, highway tunnels, and downtown San Francisco where cell coverage is surprisingly bad for a place that thinks of itself as the center of tech.`}</p>
    <p>{`But there's a way to fix this in `}<em parentName="p">{`your`}</em>{` app.`}</p>
    <h2 {...{
      "id": "the-jamstack-helps"
    }}>{`The JAMStack helps`}</h2>
    <p>{`The goal with JAMStack apps is that `}<em parentName="p">{`your first page load is useful`}</em>{`. Static HTML with all the data baked in at deploy time.`}</p>
    <p>{`You build a React app. Same as always.`}</p>
    <p>{`Fetch some data, talk to an API, render a UI. Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const ContentList = () => {
    const content = fetch(content_url)

    return (
        <ul>
            {content.map(c =>
                <li>{c.name}</li>
            )}
        <ul>
    )
}
`}</code></pre>
    <p>{`That's pseudocode but you get the idea. Load data, render data.`}</p>
    <p>{`What happens next is my favorite part.`}</p>
    <p>{`You deploy the app and it becomes a static piece of HTML. A normal file like in the old days. Served by ultra fast servers, images on a CDN, all the good stuff.`}</p>
    <p>{`When users hit your page, they get this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<html>
  <body>
    <ul>
      <li>awesome content</li>
      <li>more awesomeness</li>
      <li>wow this is amazing</li>
      <li>oh gosh not a single API request</li>
      <li>hot damn</li>
    </ul>
  </body>
</html>
`}</code></pre>
    <p>{`It's all there. No loading spinners, no API requests, not even any JavaScript. Great time to first byte, fantastic time to interactive, exceptional time to useful.`}</p>
    <p>{`😍`}</p>
    <p>{`And then `}{`[name|my friend]`}{`, then it `}<em parentName="p">{`turns into a React app`}</em>{`. After that initial load of useful content, the JavaScript flies in, hydrates your app and it becomes a typical React app. With all the features and flexibility that you're used to.`}</p>
    <p>{`That's what `}<a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}>{`The JAMStack Workshop`}</a>{` on November 9th is about. Check it out`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p><sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{` funfact: the walk to baggage claim is long and convoluted on purpose. Makes the wait feel shorter because you're walking instead of waiting.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      